<div class="grid-view-main-container" *ngIf="allData">
  <!-- Top row: search + selected count -->
  <div class="d-flex align-items-center justify-content-between mb-0">
    <!-- search input (you will style) -->
    <div>
      <div class="input-container">
        <input
          type="text"
          class="input"
          placeholder="Search contacts..."
          [value]="searchKeyword"
          (input)="onSearchInput($event)"
          [disabled]="isDisabled"
        />
      </div>
    </div>

    <!-- Selected count -->
    <div>
      <p class="mb-0 selected-contacts-label">Selected: <b>{{ selectedIds.length }} contact{{ selectedIds.length === 1 ? '' : 's' }}</b></p>
    </div>
  </div>

  <div>
    <div *ngIf="isAllSelected()">
      <div class="d-flex justify-content-end">
        <ion-button 
          class="unfilled-blue-btn btn-sm"
          (click)="toggleSelectAllContacts()">
          {{ isAllContactsSelected ? 'Unselect All Contacts' : 'Select All ' + paginationSettings.totalCount + ' Contacts' }}
        </ion-button>
      </div>
    </div>
  </div>

  <div class="table-container">
    <table class="table">
      <thead class="thead-dark sticky-top">
        <th class="column-selector-container px-0 ps-1">
          <div class="px-0">
            <input
              type="checkbox"
              class="align-middle"
              [checked]="isAllSelected()"
              [indeterminate]="isIndeterminate()"
              (change)="toggleSelectAll($event)"
              [disabled]="isDisabled || !data || !data.length"
            />
          </div>
        </th>

        <th class="id-column">
          <div class="table-heading">
            <p class="text mb-0">ID</p>
          </div>
        </th>

        <th class="name-column">
          <div class="table-heading">
            <p class="text mb-0">Name</p>
          </div>
        </th>

        <th class="phone-column">
          <div class="table-heading">
            <p class="text mb-0">Phone Number</p>
          </div>
        </th>

        <th class="phone-column">
          <div class="table-heading">
            <p class="text mb-0">DOB</p>
          </div>
        </th>
      </thead>

      <tbody>
        <tr *ngFor="let item of data; index as i; trackBy: trackByContactId">
          <td class="px-0">
            <div class="px-0 ps-1">
              <input
                type="checkbox"
                class="align-middle"
                [checked]="isSelected(item.contactId)"
                (change)="onItemToggle(item, $event)"
                [disabled]="isDisabled"
              />
            </div>
          </td>

          <td>{{ item.contactId }}</td>
          <td>{{ item.firstName }} {{ item.lastName || '' }}</td>
          <td>{{ item.phoneCountryCode }} {{ item.phoneNumber }}</td>
          <td>
            {{ item.dateOfBirth | date }}
            <span *ngIf="!item.dateOfBirth">--</span>
          </td>
        </tr>

        <tr *ngIf="data.length === 0">
          <td colspan="5" class="text-center">
            <p class="my-2">No Results Found!</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Paginations (kept exactly as your existing logic, small colspan fix) -->
  <div class="w-100 paginations-container" *ngIf="!hidePaginations">
    <div class="d-flex justify-content-between w-100">
      <div class="d-flex align-items-center">
        <div class="select-container">
          <select
            name=""
            id=""
            class="records-selector"
            [(ngModel)]="paginationSettings.pageSize"
            (change)="onPageSizeChange()"
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        </div>
        <div class="label-container">
          <p class="label">Showing {{ noOfRows }} records of {{ paginationSettings.totalCount }}</p>
        </div>
      </div>

      <div class="control-btns">
        <div class="buttons-row">
          <!-- Back btn -->
          <ion-button class="control-btn" (click)="onPrevious()" [disabled]="paginationSettings.pageNumber === 1">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </ion-button>

          <!-- pages buttons list -->
          <ion-button
            class="control-btn"
            *ngFor="let page of visiblePages"
            (click)="onPageChange(page)"
            [class.active]="page === paginationSettings.pageNumber"
          >
            {{ page }}
          </ion-button>

          <!-- Forward btn -->
          <ion-button
            class="control-btn"
            (click)="onNext()"
            [disabled]="paginationSettings.pageNumber === paginationSettings.totalPages"
          >
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
  </div>
</div>
